/**
 * @generated SignedSource<<3a1bab8413866a601a8339ac9d89e187>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type UserActivityFragment$data = {
  readonly createdAt: DateTime;
  readonly " $fragmentSpreads": FragmentRefs<"UserActivityCalendarFragment">;
  readonly " $fragmentType": "UserActivityFragment";
};
export type UserActivityFragment$key = {
  readonly " $data"?: UserActivityFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserActivityFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "date"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "kinds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserActivityFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "date",
          "variableName": "date"
        },
        {
          "kind": "Variable",
          "name": "kinds",
          "variableName": "kinds"
        }
      ],
      "kind": "FragmentSpread",
      "name": "UserActivityCalendarFragment"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8744802f13934d4a8eff17d8baec2863";

export default node;
